/* EarthBased - product gallery Swiper refresh, 21 Aug 2026

   THE GLITCH THIS FIXES
   Swiper writes the slide width onto each slide as an inline style at init and
   does not recompute it when the column is resized by CSS. eb-pdp-layout.css
   changes the gallery column width, and the column is also a percentage, so
   any window resize, zoom change, or late font/image load leaves the slides at
   a stale pixel width. The visible symptom is the next slide bleeding into the
   right-hand side of the main image, with a strip of white beside the photo.

   Measured live: after a column change the root was 606px while the slides
   still carried width:605px from a 741px-wide init; calling update() rewrote
   them to 425px and the bleed disappeared.

   WHAT IT DOES
   Calls swiper.update() on the main gallery and the thumbnail strip:
     - once the page has loaded (images can change the layout as they arrive),
     - again on a short delay for anything injected late (Fastrr, Interakt),
     - and on window resize / orientation change, debounced.

   Deliberately does NOT re-init Swiper. update() only remeasures; re-init
   would drop the active slide and re-bind handlers, and this store's main
   thread is already stalled by the duplicated Interakt SDK.

   The thumbnail strip's transform stays pinned off by CSS !important, so
   update() cannot start it sliding again. */

(function () {
  var SELECTORS = ['.product-main-slide', '.product-thumb-slide'];

  function refresh() {
    SELECTORS.forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        var sw = nodes[i].swiper;
        if (sw && typeof sw.update === 'function') {
          try { sw.update(); } catch (e) {}
        }
      }
    });
  }

  function onReady() {
    refresh();
    setTimeout(refresh, 600);
    setTimeout(refresh, 2000);
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady);
  }

  var t = null;
  function debounced() {
    if (t) clearTimeout(t);
    t = setTimeout(refresh, 150);
  }
  window.addEventListener('resize', debounced);
  window.addEventListener('orientationchange', debounced);
})();


/* EarthBased - product gallery neighbour preload, 3 Sep 2026

   THE GLITCH THIS FIXES
   Only the first two gallery images arrive with the page. Every slide after
   that carries loading=lazy, and nothing warms the next one ahead of the
   customer, so each arrow click from the third slide on starts a fresh
   download and the frame sits empty while it lands. Measured live: about
   54 KB and 110 ms per image on desktop, which becomes a one to two second
   blank frame on a slow phone connection.

   WHAT IT DOES
   Whenever the active slide changes, it warms the previous slide and the next
   two: flips loading=lazy to eager, and primes the HTTP cache with a detached
   Image carrying the same srcset and sizes, so the browser picks the same
   derivative the slide will use. The click then paints from cache.

   Only the main gallery is touched. Thumbnails are small and already visible.
   Nothing here calls update(), re-inits Swiper, or moves a slide. */

(function () {
  var MAIN = '.product-main-slide';

  function warm(img) {
    if (!img) return;
    if (img.getAttribute('loading') === 'lazy') img.setAttribute('loading', 'eager');
    if (img.complete && img.naturalWidth > 0) return;
    try {
      var probe = new Image();
      var sizes = img.getAttribute('sizes');
      var srcset = img.getAttribute('srcset');
      if (sizes) probe.sizes = sizes;
      if (srcset) probe.srcset = srcset;
      probe.src = img.getAttribute('src') || img.src;
    } catch (e) {}
  }

  function warmAround(root) {
    var slides = root.querySelectorAll('.swiper-slide');
    var n = slides.length;
    if (!n) return;
    var i = 0;
    for (; i < n; i++) {
      if (slides[i].classList.contains('swiper-slide-active')) break;
    }
    if (i >= n) i = 0;
    [i - 1, i + 1, i + 2].forEach(function (k) {
      if (k >= 0 && k < n) warm(slides[k].querySelector('img'));
    });
  }

  function bind() {
    var roots = document.querySelectorAll(MAIN);
    for (var i = 0; i < roots.length; i++) {
      (function (root) {
        warmAround(root);
        if (root.__ebWarmBound) return;
        var sw = root.swiper;
        if (sw && typeof sw.on === 'function') {
          root.__ebWarmBound = true;
          sw.on('slideChange', function () { warmAround(root); });
        }
      })(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  window.addEventListener('load', bind);
  setTimeout(bind, 1200);
  setTimeout(bind, 3000);
})();